import { loadAppSettings, setAppSettings } from './appSettings';
import { registerRuntimeRemotes } from './designSystemRemote';

const REQUIRED_SETTINGS = [
  'SHIPBOB_DESIGN_SYSTEM',
  'SHIPBOB_MFE_RUNTIME',
  'AUTHENTICATION_AUTHORITY',
  'CLIENT_ID',
  'CLIENT_SCOPE',
  'DOWNLOADS_API_URL',
  'MFE_ROOT_ROUTE',
];

/** Load settings, validate required keys (throws listing all missing), then register runtime remotes. */
export async function prepareRuntime(action) {
  const appSettings = await loadAppSettings();

  const missing = REQUIRED_SETTINGS.filter(
    (key) => typeof appSettings[key] !== 'string' || !appSettings[key].trim(),
  );
  if (missing.length) {
    // Clear cache so a subsequent attempt can refetch corrected settings.
    setAppSettings(null);
    throw new Error(`[downloads-ui] cannot ${action}: missing required app settings: ${missing.join(', ')}`);
  }

  const remotesOk = registerRuntimeRemotes(appSettings);
  if (!remotesOk) {
    throw new Error(`[downloads-ui] cannot ${action}: failed to register required runtime remotes`);
  }
}

/** Mount into a host-provided element; returns the bootloader's unmount fn. */
export const mount = async (args = {}) => {
  await prepareRuntime('mount');
  const { mount: appMount } = await import('./bootloader');
  return appMount(args);
};
